import { IWindowOptions, Window } from "./window";

export async function askNumber(title: string, def: number, options?: IWindowOptions): Promise<number | undefined> {
    const { value, isConfirmed } = await new Window().fire({
        title,
        input: 'number',
        inputValue: String(def),
        icon: 'question',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        allowEnterKey: true,
        ...options
    })
    if (isConfirmed) return Number(value)
    return undefined
}